import { ref } from "vue";
import CASP from "@/CASP";

const stats = ref(null);
const loading = ref(false);
const status = ref(null);
let request = null;

function resolveRequest(result) {
  loading.value = false;
  status.value = result.status;
  request = null;
  return result;
}

export function loadAdminSession(force = false) {
  if (!force && stats.value) {
    return Promise.resolve({ status: 200, stats: stats.value });
  }
  if (!force && request) {
    return request;
  }

  loading.value = true;
  request = new Promise((resolve) => {
    CASP.getStats((responseStatus, response) => {
      if (responseStatus === 200) {
        stats.value = response;
      } else {
        stats.value = null;
      }
      resolve(resolveRequest({ status: responseStatus, stats: stats.value }));
    });
  });

  return request;
}

export function clearAdminSession() {
  stats.value = null;
  status.value = null;
  request = null;
  if (localStorage) {
    localStorage.removeItem("stats");
  }
}

export function hasAdminAccess(requirement, permissions = {}) {
  if (!requirement) return true;
  if (requirement.anyOf) {
    return requirement.anyOf.some((permission) => typeof permission === 'string'
      ? Boolean(permissions[permission])
      : hasAdminAccess(permission, permissions));
  }
  if (requirement.allOf) {
    return requirement.allOf.every((permission) => permissions[permission]);
  }
  if (requirement.permission) {
    return Boolean(permissions[requirement.permission]);
  }
  return true;
}

export function useAdminSession() {
  return {
    stats,
    loading,
    status,
    loadAdminSession,
    clearAdminSession,
    hasAdminAccess,
  };
}
